import React, { useState, useEffect } from 'react';
import { useToasts } from 'react-toast-notifications';
import { api, globalErrorHandler } from '../api/create-api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons';
import { Row, Col, Button, UncontrolledDropdown, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, ListGroup, ListGroupItem, Modal, ModalHeader, ModalBody, ModalFooter, Popover, PopoverBody, PopoverHeader } from 'reactstrap';
import { PageTitle } from '@galop/component-library';
import { PowerBIEmbed } from 'powerbi-client-react';
import { models } from 'powerbi-client';
import { makeCall } from '../auth-utils';
import { AppName } from '../App';
import { FormatDate, FormatTime } from '../Helpers/Helper';

export const Reports = (props) => {
    const moduleName = "Reports";
    const { addToast } = useToasts();
    const [reports, setReports] = useState([]);
    const [selectedReport, setSelectedReport] = useState(null);
    const [showReport, setShowReport] = useState(true);
    const [openDropdown, setOpenDropdown] = useState(true);
    const [report, setReport] = useState(null);
    const [embedToken, setEmbedToken] = useState('');
    const [reportDesktopPages, setReportDesktopPages] = useState({});
    const [reportMobilePages, setReportMobilePages] = useState({});
    const [showRefreshModal, setShowRefreshModal] = useState(false);
    const [currentTime, setCurrentTime] = useState(null);
    const [showLocalTime, setShowLocalTime] = useState(false);

    //useEffect(() => {
    //    props.setHelpData(helpData);

    //    return () => {
    //        props.setHelpData(null);
    //    }
    //}, []);

    useEffect(() => {
        getReportsInfo();
    }, []);

    useEffect(() => {
        setShowReport(true);
        setCurrentTime(new Date(Date.now()));
    }, [selectedReport]);

    const getReportsInfo = (callback) => {
        makeCall(async (authHeader) => {
            const result = await api(`api/reports`, { headers: authHeader })
                .catch(error => globalErrorHandler(error, addToast));

            if (result && result.data) {
                setEmbedToken(result.data.embedToken);
                setReports(result.data.reports);
                if (result.data.reports.length === 1) {
                    setSelectedReport(result.data.reports[0]);
                }
            }
        });
    };

    const getReportPages = (report, view) => {
        /* Retrieve the page collection and loop through to collect the
           page name and display name of each page and display the value. */
        if (report) {
            report.getPages()
                .then(function (pages) {
                    console.log('pages', view, { ...reportDesktopPages, [view]: [...pages] });
                    if (view === 'desktop') {
                        setReportDesktopPages({ ...reportDesktopPages, [view]: [...pages] });
                    }
                    else {
                        setReportMobilePages({ ...reportDesktopPages, [view]: [...pages] });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        }
    };

    const refreshData = () => {
        makeCall(async (authHeader) => {
            const result = await api(`api/reports/refresh-data`, { headers: authHeader })
                .catch(error => globalErrorHandler(error, addToast));
        });
    };

    const toggleRefreshModal = () => setShowRefreshModal(!showRefreshModal);

    const synchronizePages = (page) => {
        const desktopPage = reportDesktopPages.desktop.find(pg => pg.name === page.name);
        const mobilePage = reportMobilePages.mobile.find(pg => pg.name === page.name);

        desktopPage.setActive();
        mobilePage.setActive();

        getReportPages(desktopPage.report, 'desktop');
        getReportPages(mobilePage.report, 'mobile');
    };

    return (
        <div className="d-flex flex-column h-100">
            <PageTitle moduleName={moduleName} size={{lg: '10', xl: '9'}} flexBehavior="flex-wrap" AppName={AppName} titleChild={
                <div className="text-dark flex-fill ms-1">
                    {(selectedReport && selectedReport.name) || (reports && reports.length > 1 && 'Select a Report')}
                    {reports && reports.length > 1 && (<Dropdown isOpen={openDropdown} toggle={() => setOpenDropdown(!openDropdown)} className="d-inline-block">
                        <DropdownToggle size="sm" color="light" className="border ms-1"><FontAwesomeIcon icon={faCaretDown} /></DropdownToggle>
                        <DropdownMenu end className="shadow">
                            {reports.map(report => <DropdownItem key={report.id} active={report.id === (selectedReport || {}).id} onClick={() => setSelectedReport(reports.find(rpt => rpt.id === report.id))}>{report.name}</DropdownItem>)}
                        </DropdownMenu>
                    </Dropdown>)}
                </div>
            } />
            <div className="flex-fill h-100">
                <div className="d-flex flex-column flex-lg-row h-100">
                    {reportDesktopPages && (reportDesktopPages.desktop || reportMobilePages.mobile || []).filter(page => page.visibility === 0).length > 1 ?
                        <div className="me-0 me-lg-3 mb-2 mb-lg-0">
                            <Row className="d-lg-none align-items-end">
                                <Col className="pe-0 pe-sm-3">
                                    <label className="me-1 mb-0">View:</label>
                                    {reportMobilePages.mobile &&
                                        <UncontrolledDropdown>
                                            <DropdownToggle size="sm" color="light" className="border text-nowrap">{((reportMobilePages.mobile || []).find(page => page.isActive) || {}).displayName} <FontAwesomeIcon icon={faCaretDown} /></DropdownToggle>
                                            <DropdownMenu>
                                                {reportMobilePages.mobile.filter(page => page.visibility === 0).map(page => <DropdownItem key={page.name} className="cursor-pointer" active={page.isActive} onClick={() => {
                                                    synchronizePages(page);
                                                }}>{page.displayName}</DropdownItem>)}
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    }
                                </Col>
                            </Row>
                            <div className="h-100 d-none d-lg-flex flex-column">
                                <fieldset>
                                    <legend>View</legend>
                                </fieldset>
                                <div className="border flex-fill rounded h-100" style={{ overflowY: 'auto', overflowX: 'hidden' }}>
                                    {reportDesktopPages.desktop &&
                                        <ListGroup flush className="border-bottom">
                                            {reportDesktopPages.desktop.filter(page => page.visibility === 0).map(page => <ListGroupItem key={page.name} className="cursor-pointer" action active={page.isActive} onClick={() => {
                                                synchronizePages(page);
                                            }}>{page.displayName}</ListGroupItem>)}
                                        </ListGroup>
                                    }
                                </div>
                            </div>
                        </div>
                        :
                        <div className="d-block d-sm-none mb-2">
                        </div>
                    }
                    <div className="h-100 flex-fill d-flex flex-column mt-2 mt-sm-0 mb-5 mb-sm-0">
                        {showReport ?
                            <div className="border rounded scrollable-list h-100 flex-fill">
                                <PowerBIEmbed
                                    embedConfig={{
                                        type: 'report',   /* Supported types: report, dashboard, tile, visual and qna */
                                        id: (selectedReport || {}).id,
                                        embedUrl: (selectedReport || {}).embedUrl,
                                        accessToken: embedToken,
                                        tokenType: models.TokenType.Embed,
                                        pageView: 'fitToWidth',
                                        settings: {
                                            panes: {
                                                filters: {
                                                    visible: true
                                                },
                                                pageNavigation: {
                                                    visible: false
                                                }
                                            },
                                            background: models.BackgroundType.Transparent
                                        }
                                    }}

                                    /* Define event handlers */
                                    eventHandlers={
                                        new Map([
                                            ['loaded', function (e, report) {
                                                setReport(report);
                                                getReportPages(report, 'desktop');
                                            }],
                                            ['rendered', function () { console.log('Report rendered'); }],
                                            ['error', function (event) {
                                                setShowReport(false);
                                                console.log(event.detail);
                                            }]
                                        ])}

                                    /* Add CSS classes to the div element */
                                    cssClassName={"w-100 h-100 d-none d-lg-block"}

                                    /* Get reference to the embedded object */
                                    getEmbeddedComponent={(embeddedReport) => {
                                        console.log('embeddedReport', embeddedReport);
                                    }}
                                />
                                <PowerBIEmbed
                                    embedConfig={{

                                        type: 'report',   /* Supported types: report, dashboard, tile, visual and qna */
                                        id: (selectedReport || {}).id,
                                        embedUrl: (selectedReport || {}).embedUrl,
                                        accessToken: embedToken,
                                        tokenType: models.TokenType.Embed,
                                        pageView: 'fitToWidth',
                                        settings: {
                                            panes: {
                                                filters: {
                                                    visible: true
                                                },
                                                pageNavigation: {
                                                    visible: false
                                                }
                                            },
                                            background: models.BackgroundType.Transparent,
                                            layoutType: models.LayoutType.MobilePortrait
                                        }
                                    }}

                                    /* Define event handlers */
                                    eventHandlers={
                                        new Map([
                                            ['loaded', function (e, report) {
                                                setReport(report);
                                                getReportPages(report, 'mobile');
                                            }],
                                            ['rendered', function () { console.log('Report rendered'); }],
                                            ['error', function (event) {
                                                setShowReport(false);
                                                console.log(event.detail);
                                            }]
                                        ])}

                                    /* Add CSS classes to the div element */
                                    cssClassName={"w-100 h-100 d-block d-lg-none"}

                                    /* Get reference to the embedded object */
                                    getEmbeddedComponent={(embeddedReport) => {
                                        console.log('embeddedReport', embeddedReport);
                                    }}
                                />
                            </div>
                            :
                            <div className="border rounded scrollable-list h-100 flex-fill">
                                <div className="p-2">
                                    <span>Unfortunately, there has been an issue with displaying the report, at the moment. Please <Button color="light" className="border" tag="a" href="https://greystar.service-now.com/sp?id=sc_cat_item&sys_id=0294b374db53d4101776138b4b9619cd" target="_blank">set up a ticket</Button> so the team will work on it.</span>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

const helpData = {
    title: 'Reports',
    sections: [
        {
            data: <div>
                <ul>
                    <li>
                        Select a report to display.
                    </li>
                    <li>
                        Once loaded, you'll see a display in the bottom-right corner of the time the reports were most recently updated.
                        <ul>
                            <li>
                                Note: This time is in Greenwich Mean Time (GMT), so click the time to see it translated to your time zone.
                            </li>
                        </ul>
                    </li>
                    <li>
                        the report data is updated automatically every morning at 6 AM.
                    </li>
                    <li>
                        Click "Refresh Report Data" to manually kick off an update of the report data.
                    </li>
                </ul>
            </div>
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/Reports.js